import {order} from '../apps/aife/aife-menu'

const isHomePath = path => path.includes('____l____e____x____e____r____')

export const highlightState = {
    defaultState: (path = window.location.pathname) => ({
        highlighted: isHomePath(path) ? order[0] : null,
        highlighting: isHomePath(path),
        highlightedHistory: [].filter(Boolean),
    }),
    actions: {
        stopHighlighting: (_, state) => ({
            ...state,
            highlighting: false,
        }),
        startHighlighting: (highlighted, state) => ({
            ...state,
            highlighting: true,
            highlighted: highlighted !== undefined ? highlighted : state.highlighted,
        }),
        nextHighlighted: (_, state) => {
            return {
                ...state,
                highlighted: order[(order.indexOf(state.highlighted) + 1) % order.length],
                prevHighlighted: state.highlighted,
                order: order,
                highlighting: true,
                // highlightedHistory: [...state.highlightedHistory, state.prevHighlighted],
            }
        },
        // nextHighlighted: (_, state) => {
        //     let index = 0
        //     let nextHighlighted = order[index]
        //     while ((state.highlightedHistory.includes(nextHighlighted) || state.highlighted === nextHighlighted) && index < order.length) {
        //         nextHighlighted = order[index++]
        //     }
        //     return {
        //         ...state,
        //         highlighted: nextHighlighted,
        //         prevHighlighted: state.highlighted,
        //         order: order,
        //         highlighting: true,
        //         highlightedHistory: [...state.highlightedHistory, state.prevHighlighted].filter(Boolean),
        //     }
        // },
        setHighlighted: (highlighted, state) => ({
            ...state,
            highlighted: highlighted,
        }),
        clearHighlighted: (_, state) => ({
            ...state,
            highlighted: null,
            highlighting: false,
            highlightedHistory: [],
        }),
    },
}
